var map = {
	"./copyright_lgd.png": [
		986,
		8
	],
	"./logo.svg": [
		987,
		5
	],
	"./logo_hanabank.svg": [
		988,
		6
	],
	"./logo_lgd.png": [
		989,
		9
	],
	"./monitor.png": [
		377
	],
	"./monitor2.svg": [
		990,
		7
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 514;
module.exports = webpackAsyncContext;